import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { useClientStore } from '@/features/clients/store/client.store'
import { useNegotiationsStore } from '@/features/negotiations/store/negotiations.store'
import { formatCode } from '@/shared/constants/config'
import { type BreadcrumbOverride, useHeaderNavStore } from '@/shared/store/header-nav.store'
import { buildRouteContext } from '@/shared/utils/route-context'

export function useRouteContext() {
  const { pathname } = useLocation()
  const manualOverrides = useHeaderNavStore((state) => state.breadcrumbOverrides)
  const clientId = useClientStore((state) => state.clientOriginal?._id)
  const clientName = useClientStore((state) => state.clientOriginal?.name)
  const negotiationId = useNegotiationsStore((state) => state.id)
  const negotiationCode = useNegotiationsStore((state) => state.code)

  const overrides = useMemo(() => {
    const entityOverrides: BreadcrumbOverride[] = []

    if (clientId && clientName) {
      entityOverrides.push({ segment: clientId, label: clientName })
    }

    if (negotiationId && negotiationCode) {
      entityOverrides.push({
        segment: negotiationId,
        label: formatCode(negotiationCode)
      })
    }

    const manualSegments = new Set(manualOverrides.map((override) => override.segment))
    return [
      ...manualOverrides,
      ...entityOverrides.filter((override) => !manualSegments.has(override.segment))
    ]
  }, [clientId, clientName, negotiationId, negotiationCode, manualOverrides])

  return useMemo(() => buildRouteContext(pathname, overrides), [pathname, overrides])
}
